(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["charwee-bundle-new"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('custom-charwee-bundle')) {
  customElements.define('custom-charwee-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.limit = Number(this.dataset.limit || 3);
      this.selected = new Map();
      this.busy = false;
      this.bundleVariants = JSON.parse(this.querySelector('[data-ccb-bundle-variants]').textContent || '{}');
      this.cards = [...this.querySelectorAll('.ccb__card')];
      this.submit = this.querySelector('.ccb__submit');
      this.error = this.querySelector('.ccb__error');
      this.status = this.querySelector('.ccb__status');
      this.slots = this.querySelector('.ccb__slots');

      this.cards.forEach((card) => {
        const button = card.querySelector('.ccb__add');
        button.dataset.unavailable = button.disabled ? 'true' : 'false';
        button.addEventListener('click', () => this.toggle(card));
        card.querySelector('.ccb__variant')?.addEventListener('change', (event) => {
          const option = event.target.selectedOptions[0];
          card.dataset.variant = option.value;
          card.dataset.price = option.dataset.price;
          card.querySelector('.ccb__price').textContent = option.dataset.priceText;
        });
      });
      this.submit.addEventListener('click', () => this.addToCart());
      this.render();
    }

    toggle(card) {
      if (this.busy) return;
      const key = card.dataset.product;
      if (this.selected.has(key)) {
        this.selected.delete(key);
      } else {
        if (this.selected.size >= this.limit) return;
        this.selected.set(key, {
          id: String(card.dataset.variant),
          index: Number(card.dataset.index),
          title: card.dataset.title,
          price: Number(card.dataset.price),
          image: card.querySelector('img')?.currentSrc || card.querySelector('img')?.src || '',
          card
        });
      }
      this.error.hidden = true;
      this.render();
    }

    render() {
      const count = this.selected.size;
      this.cards.forEach((card) => {
        const chosen = this.selected.has(card.dataset.product);
        const button = card.querySelector('.ccb__add');
        button.disabled = this.busy || button.dataset.unavailable === 'true' || (!chosen && count >= this.limit);
        button.setAttribute('aria-pressed', String(chosen));
        if (button.dataset.unavailable !== 'true') button.textContent = chosen ? 'Remove' : 'Add to bundle';
        card.querySelector('.ccb__selected-mark').hidden = !chosen;
        const selector = card.querySelector('.ccb__variant');
        if (selector) selector.disabled = chosen || this.busy;
      });

      this.status.textContent = count === this.limit ? 'Bundle ready — add it to cart.' : `${count} of ${this.limit} selected`;
      this.querySelector('.ccb__bar-count').textContent = `${count} of ${this.limit} selected`;
      this.slots.replaceChildren();
      const selectedItems = [...this.selected.values()];
      const originalTotal = selectedItems.reduce((sum, item) => sum + item.price, 0);
      const originalPrice = this.querySelector('.ccb__original-total');
      originalPrice.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: this.dataset.currency || 'INR' }).format(originalTotal / 100);
      originalPrice.hidden = count !== this.limit || originalTotal <= Number(this.dataset.price);

      for (let i = 0; i < this.limit; i++) {
        const item = selectedItems[i];
        const slot = document.createElement(item ? 'button' : 'span');
        slot.className = 'ccb__slot';
        if (item) {
          slot.type = 'button';
          slot.disabled = this.busy;
          slot.title = `Remove ${item.title}`;
          if (item.image) {
            const image = document.createElement('img');
            image.src = item.image;
            image.alt = item.title;
            slot.append(image);
          }
          const label = document.createElement('small');
          label.textContent = 'Remove';
          slot.append(label);
          slot.addEventListener('click', () => this.toggle(item.card));
        }
        this.slots.append(slot);
      }
      this.submit.disabled = this.busy || count !== this.limit;
      this.submit.textContent = this.busy ? 'Adding…' : 'Add bundle to cart';
    }

    async addToCart() {
      if (this.busy || this.selected.size !== this.limit) return;
      this.busy = true;
      this.error.hidden = true;
      this.render();

      try {
        const selectedItems = [...this.selected.values()];
        const indexes = selectedItems.map((item) => item.index).sort((a, b) => a - b);
        const combination = `Selection ${indexes.join('-')}`;
        const bundleVariantId = this.bundleVariants[combination];
        if (!bundleVariantId) throw new Error(`Bundle combination ${combination} is not configured.`);

        const group = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`);
        const properties = { _charwee_bundle_id: group, _charwee_bundle_offer: 'buy3_999', _bundle_combination: combination };
        selectedItems.forEach((item, index) => {
          properties[`_selected_variant_${index + 1}`] = item.id;
          properties[`Product ${index + 1}`] = item.title;
        });

        const cartDrawer = document.querySelector('cart-drawer');
        const payload = {
          items: [{ id: String(bundleVariantId), quantity: 1, properties }]
        };

        if (cartDrawer) {
          payload.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          cartDrawer.setActiveElement(this.submit);
        }

        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add bundle to cart.');

        if (cartDrawer && data.sections) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
          cartDrawer.open(this.submit);
          this.selected.clear();
          this.busy = false;
          this.render();
        } else {
          window.location.assign(this.dataset.cartUrl);
        }
      } catch (error) {
        console.error('[CharweeBundle]', error);
        this.error.textContent = error.message || 'Unable to add bundle to cart.';
        this.error.hidden = false;
        this.busy = false;
        this.render();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
